import { graphql } from '../../generated';

export const REGENERATE_API_TOKEN = graphql(`
  mutation RegenerateApiToken {
    regenerateApiToken(input: {}) {
      membership {
        token
      }
    }
  }
`);
